import type { WorkingHour } from './WorkingHour';

export class WorkingHourOverride {
  constructor(
    readonly id: string,
    readonly date: Date,
    readonly workingHour: WorkingHour,
  ) {}
}
